import './markdown.scss';

import React from 'react';
import marked from 'marked';

interface Props {
  children: string | null;
  prerendered?: boolean;
}

export default function Markdown(props: Props) {
  const { children, prerendered } = props;

  if (children == null) {
    return null;
  }

  const content = prerendered ? children : marked(children);

  return (
    <div className="Markdown" dangerouslySetInnerHTML={{ __html: content }} />
  );
}
